<div class="login-container">
  <mat-card appearance="raised" class="login-card" (keyup.enter)="login()">
    <mat-progress-bar class="progress-loader" [mode]="loginLoading ? 'indeterminate' : 'determinate'" value="0" color="primary"></mat-progress-bar>
    <mat-card-header>
      <mat-card-title>Login</mat-card-title>
    </mat-card-header>
    <mat-card-content style="padding-top: 12px;">
      <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill" class="login-card-input">
        <mat-label>Username</mat-label>
        <input matInput type="text" [(ngModel)]="username">
        @if (username) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="username=''" class="clear-icon-button">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
      <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill" class="login-card-input">
        <mat-label>Password</mat-label>
        <input matInput [type]="hidePassword ? 'password' : 'text'" [(ngModel)]="password"/>
        <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hidePassword">
          <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field subscriptSizing="fixed" provideReadonly appearance="fill" class="login-card-input">
        <mat-label>Organization</mat-label>
        <input matInput type="text" [(ngModel)]="organization"/>
        @if (organization) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="organization=''">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
      <p class="terms">*by using Invflow system you agree to the terms at <a href="https://app.invflow.com/terms">https://app.invflow.com/terms</a></p>
    </mat-card-content>
    <mat-card-actions align="start">
      <button mat-button (click)="login()">LOGIN</button>
      <button mat-button disabled>FORGOT PASSWORD</button>
    </mat-card-actions>
  </mat-card>
</div>




